import React, { useState, useRef } from 'react';

import {ObjectUtils} from "../../../Utils";

import {FileEditOverlay} from './FileEditOverlay';

import {service as FileUploadService} from "../../../Services/FileUploadService";
import {useEditFileUpload, usePermission} from "../../../Hooks/PermissionHooks";

export const useFileEditor = (onFileChanged = () => {}) => {

    const hasPermission = usePermission();
    const canEditFileUpload = useEditFileUpload();
    
    const [isShown, setIsShown] = useState(false);
    const [validation, setValidation] = useState([]);
    const [file, setFile] = useState(null);
    const [editedFile, setEditedFile] = useState(null);
    const componentRef = useRef(null);
    
    const canEdit = editedFile
        ? canEditFileUpload(editedFile)
        : false;
    
    const showFileEditor = (fileToEdit) => {
        setFile(fileToEdit);
        setEditedFile(ObjectUtils.Clone(fileToEdit));
        setIsShown(true);
    };
    
    const hideFileEditor = () => {
        setIsShown(false);
    };
    
    const saveFile = () => {
        FileUploadService.UpdateFile(editedFile)
            .then(() => {
                setIsShown(false);
                
                // If we're composing a component with a reload call back. Lets trigger it..
                // Warning: because of the way we are using this composedComponent ref
                // FileEditorEnhance must be the last included decorator to ensure this
                // ref doesn't point to another HOC.
                onFileChanged(editedFile);
            })
            .catch((error) => {
                alert(error?.message ?? "Unknown Error");
            });
    };
    
    const deleteFile = () => {
        FileUploadService.DeleteFile(editedFile.fileUploadId)
            .then(() => {
                hideFileEditor();
                onFileChanged(editedFile);
            });
    }
    
    const fileEditorComponent = <FileEditOverlay
        key="file-editor-component"
        Display={isShown}
        OnClose={hideFileEditor}
        OnSave={saveFile}
        OnDelete={hasPermission('delete_file') ? deleteFile : null}
        CanDelete={canEdit && hasPermission('delete_file')}
        File={editedFile}
        OnUpdate={setEditedFile}
        OnValidationUpdate={setValidation}
        Validation={validation}
    />;
    
    return [showFileEditor, hideFileEditor, fileEditorComponent];
}

